/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDomainsBlocklistRecord } from './CRSFDomainsBlocklistRecord';
import {
    CRSFDomainsBlocklistRecordFromJSON,
    CRSFDomainsBlocklistRecordFromJSONTyped,
    CRSFDomainsBlocklistRecordToJSON,
} from './CRSFDomainsBlocklistRecord';

/**
 * 
 * @export
 * @interface CRSFDomainsBlocklist
 */
export interface CRSFDomainsBlocklist {
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainsBlocklist
     */
    assets: number;
    /**
     * 
     * @type {Array<CRSFDomainsBlocklistRecord>}
     * @memberof CRSFDomainsBlocklist
     */
    results: Array<CRSFDomainsBlocklistRecord>;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainsBlocklist
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFDomainsBlocklist interface.
 */
export function instanceOfCRSFDomainsBlocklist(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFDomainsBlocklistFromJSON(json: any): CRSFDomainsBlocklist {
    return CRSFDomainsBlocklistFromJSONTyped(json, false);
}

export function CRSFDomainsBlocklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainsBlocklist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': json['assets'],
        'results': ((json['results'] as Array<any>).map(CRSFDomainsBlocklistRecordFromJSON)),
        'total': json['total'],
    };
}

export function CRSFDomainsBlocklistToJSON(value?: CRSFDomainsBlocklist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': value.assets,
        'results': ((value.results as Array<any>).map(CRSFDomainsBlocklistRecordToJSON)),
        'total': value.total,
    };
}

